import { render, staticRenderFns } from "./TestWelcome.vue?vue&type=template&id=089f6852&scoped=true&"
import script from "./TestWelcome.vue?vue&type=script&lang=js&"
export * from "./TestWelcome.vue?vue&type=script&lang=js&"
import style0 from "./TestWelcome.vue?vue&type=style&index=0&id=089f6852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f6852",
  null
  
)

export default component.exports